import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const LabsSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default LabsSVG;
